import { render, staticRenderFns } from "./CommsPageDesktop.vue?vue&type=template&id=4da076fa&"
import script from "./CommsPageDesktop.vue?vue&type=script&lang=js&"
export * from "./CommsPageDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports